import { render, staticRenderFns } from "./MovableTextBoxObject.vue?vue&type=template&id=3f44c7de&scoped=true&"
import script from "./MovableTextBoxObject.vue?vue&type=script&lang=ts&"
export * from "./MovableTextBoxObject.vue?vue&type=script&lang=ts&"
import style0 from "./MovableTextBoxObject.vue?vue&type=style&index=0&id=3f44c7de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f44c7de",
  null
  
)

export default component.exports